"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SskyPromise = void 0;
const es6_promise_pool_1 = __importDefault(require("es6-promise-pool"));
class SskyPromise {
    /**
     * Creates a Promise that is resolved with an array of results when all of the provided Promises resolve, or rejected when any Promise is rejected.
     * Unlike Promise.all(), it can also limit the number of concurrent Promises
     * @param promiseGenerationArray an array of functions that generates Promises
     * @param concurrency number of concurrent Promises that can run simultaneously
     * @param progressFunc (optional) a callback function that gets updated with progress percentage (0-100)
     * @returns Promise<A> a new Promise that resolves to an array of the accumulated resolution of all Promises
     */
    static all(promiseGenerationArray, concurrency, progressFunc) {
        // Resolution accumulator
        const acc = {};
        /**
         * Checks if there's a progress function callback and updates progress
         */
        function updateProgress() {
            if (typeof progressFunc === "function") {
                const progress = 100 * Object.keys(acc).length / promiseGenerationArray.length;
                progressFunc(progress);
            }
        }
        /**
         * Wraps a Promise with a Promise to accumulate result
         * @param promiseGenerationFunction the function that generates the Promise
         * @param index the index for the accumulator
         * @returns {Promise<A>}
         */
        function wrapPromise(promiseGenerationFunction, index) {
            return __awaiter(this, void 0, void 0, function* () {
                const res = yield promiseGenerationFunction();
                acc[index] = res;
                updateProgress();
                return res;
            });
        }
        if (!concurrency) {
            // Generate the array of Promises (using wrapPromise, so that progressFunc will be called)
            const promises = promiseGenerationArray.map((item, index) => wrapPromise(item, index));
            return Promise.all(promises);
        }
        /**
         * Creates an IterableIterator for the Promises
         * @param promiseGenerationArray an array of functions that generates Promises
         * @returns {IterableIterator<Promise<A>>}
         */
        function* generatePromises(promiseGenerationArray) {
            for (const { item, index } of promiseGenerationArray.map((item, index) => ({ item, index }))) {
                yield wrapPromise(item, index);
            }
        }
        // run functions in a pool, limiting concurrency
        const promiseIterator = generatePromises(promiseGenerationArray);
        // @ts-ignore
        const promisePool = new es6_promise_pool_1.default(promiseIterator, concurrency);
        return new Promise((resolve, reject) => {
            promisePool.start().then(() => resolve(Object.values(acc)), (err) => reject(err));
        });
    }
}
exports.SskyPromise = SskyPromise;
//# sourceMappingURL=sskyPromise.js.map